import { RaRecord, useTranslate } from 'ra-core'
import { Datagrid, FunctionField, List, ListProps, Pagination, TextField } from 'react-admin'

import BulkActionButtons from 'components/common/BulkActionButtons'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import { formatDateString } from 'utils/formatDateString'
import DateFieldCustom from 'utils/overrides/DateFieldCustom'
import DatagridPublishedColumnContent from '../../components/common/DatagridPublishedColumnContent'
import { DEFAULT_PER_PAGE, ROWS_PER_PAGE } from '../../globalVariables'
import RetailerYearListFilter from './RetailerYearListFilters'

const RetailerYearList = (props: ListProps) => {
    const translate = useTranslate()

    return (
        <List
            {...props}
            sort={{ field: 'name', order: 'DESC' }}
            perPage={DEFAULT_PER_PAGE}
            filters={RetailerYearListFilter}
            pagination={<Pagination rowsPerPageOptions={ROWS_PER_PAGE} />}
            empty={false}
            sx={{
                '& .RaDatagrid-headerCell': {
                    fontWeight: 700
                },
                form: {
                    minHeight: 'unset',
                    alignItems: 'center',
                    '.MuiFormControl-root': {
                        marginTop: '0 !important'
                    },
                    '.filter-field': {
                        alignItems: 'center',
                        '.RaFilterFormInput-hideButton': {
                            marginBottom: 0
                        }
                    }
                }
            }}
        >
            <Datagrid
                body={<CustomDatagridBody />}
                rowClick="edit"
                bulkActionButtons={<BulkActionButtons />}
            >
                <TextField source="name" label={translate('manager.resources.retailerYear.name')} />
                <FunctionField
                    source="active"
                    label={translate('manager.resources.general.status')}
                    render={(record: RaRecord) => (
                        <DatagridPublishedColumnContent record={record} />
                    )}
                />
                <DateFieldCustom
                    label={translate('manager.resources.general.last_updated')}
                    source="updated_at"
                    showTime
                    transform={(value) => formatDateString(value, true)}
                />
            </Datagrid>
        </List>
    )
}
export default RetailerYearList
